import { render, staticRenderFns } from "./ImgBox.vue?vue&type=template&id=489979e7&scoped=true&"
import script from "./ImgBox.vue?vue&type=script&lang=js&"
export * from "./ImgBox.vue?vue&type=script&lang=js&"
import style0 from "./ImgBox.vue?vue&type=style&index=0&id=489979e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489979e7",
  null
  
)

export default component.exports